import moment from 'moment';
import Request from './../../request';
import { IIncomeSummaryProps } from '../../../props/finance/incomes';

// import props

const IncomeService = {
    summary: async (qs?: string): Promise<IIncomeSummaryProps> => {
        try {
            const result = await Request.get(`/api/incomes/summary?${qs || ""}`);
            return result;
        } catch (e) {
            throw (e);
        }
    }
}

export default IncomeService;